export const faqReducer = (state = {}, action) => {
    switch (action.type) {
        case "GET_FAQS_REQUEST":
            return {
                ...state,
                loading: true,
            };

        case "GET_FAQS_SUCCESS":
            return {
                ...state,
                loading: false,
                success: true,
                data: action.payload,
            };

        case "GET_FAQS_FAILURE":
            return {
                ...state,
                loading: false,
                success: false,
                error: action.payload,
            };

        case "ADD_FAQ_REQUEST":
        case "UPDATE_FAQ_REQUEST":
            return {
                ...state,
                loading: true,
                error: null,
                success: false,
            };

        case "ADD_FAQ_SUCCESS":
            return {
                ...state,
                loading: false,
                success: true,
                data: {
                    ...state.data,
                    data: [...(state.data?.data || []), action.payload.data], // append to list
                },
            };

        case "UPDATE_FAQ_SUCCESS":
            return {
                ...state,
                loading: false,
                success: true,
                data: {
                    ...state.data,
                    data: (state.data?.data || []).map((faq) =>
                        faq._id === action.payload.data._id ? action.payload.data : faq
                    ),
                },
            };

        case "ADD_FAQ_FAILURE":
        case "UPDATE_FAQ_FAILURE":
            return {
                ...state,
                loading: false,
                success: false,
                error: action.payload,
            };

        default:
            return state;
    }
};
